<ngx-loading-bar [diameter]="'50px'"></ngx-loading-bar>
<!-- <mat-spinner color="indeterminate" aria-label="Loading"></mat-spinner> -->
<!-- <mat-progress-bar mode="indeterminate" [value]="loader.progress$ | async"></mat-progress-bar> -->
<router-outlet></router-outlet>
